module.exports = __webpack_public_path__ + "assets/img/5_1165_big.a66201d4.jpg";